var React = require('react');

function Checked (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"check","d":"M175.251,367.463l-6.635-6.635,1.028-1.016,5.607,5.607L187.2,353.463l1.028,1.028Z","transform":"translate(-168.616 -353.463)","fill":"#06c"}));
}

Checked.defaultProps = {"width":"19.607","height":"14","viewBox":"0 0 19.607 14"};

module.exports = Checked;

Checked.default = Checked;
